import React from 'react';
import { PRIMARY, cn } from '../constants/theme';

interface FooterProps {
  dark: boolean;
}

export function Footer({ dark }: FooterProps) {
  return (
    <div className="px-6 md:px-40 flex justify-center py-20 mt-auto">
      <div
        className={cn(
          'flex flex-col max-w-[960px] flex-1 border-t pt-10 px-4',
          dark ? 'border-[#283539]' : 'border-slate-200'
        )}
      >
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div
            className={cn(
              'text-sm mono-text',
              dark ? 'text-slate-400' : 'text-slate-500'
            )}
          >
            © {new Date().getFullYear()} Fateh OK. All rights reserved.
          </div>
          <div
            className={cn(
              'flex gap-6 text-sm mono-text',
              dark ? 'text-slate-400' : 'text-slate-500'
            )}
          >
            <a
              className="transition-colors hover:text-[var(--primary)]"
              href="https://github.com/fetahokey"
              target="_blank"
              rel="noopener noreferrer"
              style={{ '--primary': PRIMARY } as React.CSSProperties}
            >
              Github
            </a>
            <a
              className="transition-colors hover:text-[var(--primary)]"
              href="https://www.linkedin.com/in/fetahok/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ '--primary': PRIMARY } as React.CSSProperties}
            >
              LinkedIn
            </a>
            <a
              className="transition-colors hover:text-[var(--primary)]"
              href="/rss.xml"
              style={{ '--primary': PRIMARY } as React.CSSProperties}
            >
              RSS
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
